module.exports = __webpack_public_path__ + "static/media/larry_q50.c492656f.webp";